module.exports = __webpack_public_path__ + "img/inst-modal-9.5567cb00.png";